import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMCanalVenda } from 'src/app/models/crm/crmcanal-venda';
import { CRMFiltroOportunidade } from 'src/app/models/crm/crmfiltro-oportunidade';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { CRMResposta } from 'src/app/models/crm/crmresposta';
import { CRMTag } from 'src/app/models/crm/crmtag';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { CrmcanalVendaService } from 'src/app/services/crm/crmcanal-venda.service';
import { CrmoportunidadeService } from 'src/app/services/crm/crmoportunidade.service';
import { CrmrespostaService } from 'src/app/services/crm/crmresposta.service';
import { CrmtagService } from 'src/app/services/crm/crmtag.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { CRM } from 'src/app/models/crm/crmfunil';

@Component({
  selector: 'app-filtro-oportunidade',
  templateUrl: './filtro-oportunidade.component.html',
  styleUrls: ['./filtro-oportunidade.component.scss']
})
export class FiltroOportunidadeComponent implements OnInit {
  filtroOportunidade: CRMFiltroOportunidade;
  idCRM;
  canaisDeVenda: CRMCanalVenda[] = [];
  usuarios: CRMHierarquiaUsuario[] = [];
  respostas: CRMResposta[] = [];
  tags: CRMTag[] = [];

  ordenacoes: any[] = [
    { id: 0, nome: 'Alfabética crescente', campo: 'titulo', ascDesc: 'asc' },
    { id: 1, nome: 'Alfabética decrescente', campo: 'titulo', ascDesc: 'desc' },
    { id: 2, nome: 'Data crescente', campo: 'dtabertura', ascDesc: 'asc' },
    { id: 3, nome: 'Data decrescente', campo: 'dtabertura', ascDesc: 'desc' },
    { id: 4, nome: 'Valor crescente', campo: 'valorestimado', ascDesc: 'asc' },
    { id: 5, nome: 'Valor decrescente', campo: 'valorestimado', ascDesc: 'desc' }
  ];

  periodos: any[] = [
    { id: 0, nome: 'Todos' },
    { id: 1, nome: 'Hoje' },
    { id: 2, nome: 'Ontem' },
    { id: 3, nome: 'Esta semana' },
    { id: 4, nome: 'Semana passada' },
    { id: 5, nome: 'Este mês' },
    { id: 6, nome: 'Mês passado' },
    { id: 7, nome: 'Personalizado' }
  ];

  status: any[] = [
    { id: -1, nome: 'Todos' },
    { id: 0, nome: 'Aberta' },
    { id: 1, nome: 'Negativo' },
    { id: 2, nome: 'Positivo' }
  ];

  cidades: string[] = [];
  idUser;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private oportunidadeService: CrmoportunidadeService,
    private clienteService: ClienteService,
    private router: Router,
    private canalDeVendaService: CrmcanalVendaService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private respostaService: CrmrespostaService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FiltroOportunidadeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tagService: CrmtagService
  ) {
    this.filtroOportunidade = data.filtro;
    this.idCRM = data.idCRM;

    if (data.crm.habilitaGanho && data.crm.habilitaPerda) {
      this.status[2].id = 2;
      this.status[2].nome = data.crm.textoGanho;
      this.status[3].id = 1;
      this.status[3].nome = data.crm.textoPerda;
    } else if (data.crm.habilitaGanho) {
      this.status[2].id = 2;
      this.status[2].nome = data.crm.textoGanho;
      this.status.splice(3, 1);
    } else if (data.crm.habilitaPerda) {
      this.status[3].id = 1;
      this.status[3].nome = data.crm.textoPerda;
      this.status.splice(2, 1);
    }
  }

  async ngOnInit() {
    this.idUser = (await this.globalService.consultaUsuario()).id;
    this.buscarCanaisDeVenda();
    this.buscarRespostas();
    this.buscarUsuarios();
    this.buscarCidades();
    this.buscarTags();
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags().subscribe(
      (tags) => {
        this.tags = tags;

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCidades() {
    this.carregandoService.mostra('buscaCidades');
    this.clienteService.consultarCidadesDosClientes().subscribe(cidades => {
      this.cidades = cidades;
      this.carregandoService.esconde('buscaCidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaCidades');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCanaisDeVenda() {
    this.carregandoService.mostra('buscaCanaisDeVenda');

    this.canalDeVendaService.consultarCanaisVenda().subscribe(resp => {
      this.canaisDeVenda = resp;

      const todos = new CRMCanalVenda();
      todos.id = 0;
      todos.descricao = 'Todos';

      this.canaisDeVenda.unshift(todos);

      this.carregandoService.esconde('buscaCanaisDeVenda');
    }, (erro) => {
      this.carregandoService.esconde('buscaCanaisDeVenda');
      this.notificacaoService.erro(erro);
    });
  }

  buscarRespostas() {
    if (this.filtroOportunidade.status === 0) {
      return;
    }

    this.carregandoService.mostra('buscaRespostas');
    this.respostaService.consultarRespostas(this.filtroOportunidade.status === 1 ? 0 : 1).subscribe(resp => {
      this.respostas = resp;
      const todos = new CRMResposta();
      todos.id = 0;
      todos.descricao = 'Todas';

      this.respostas.unshift(todos);

      this.carregandoService.esconde('buscaRespostas');
    }, (erro) => {
      this.carregandoService.esconde('buscaRespostas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsuarios() {
    this.carregandoService.mostra('buscaUsuarios');

    this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
      this.usuarios = resp;

      this.usuarios.splice(this.usuarios.
        indexOf(this.usuarios.find(p => p.idFuncion === Number(this.idUser))), 1);

      const todos = new CRMHierarquiaUsuario();
      todos.idFuncion = 0;
      todos.nome = 'Todos';
      this.usuarios.unshift(todos);

      const somenteEu = new CRMHierarquiaUsuario();
      somenteEu.idFuncion = -1;
      somenteEu.nome = 'Somente eu';
      this.usuarios.unshift(somenteEu);

      this.carregandoService.esconde('buscaUsuarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaUsuarios');
      this.notificacaoService.erro(erro);
    });
  }

  filtrar() {
    const ordenacao = this.ordenacoes.find(p => p.id === this.filtroOportunidade.idOrdenacao);

    this.filtroOportunidade.campoOrdenacao = ordenacao.campo;
    this.filtroOportunidade.ascDesc = ordenacao.ascDesc;

    if (!this.filtroOportunidade.idOportunidade) {
      this.filtroOportunidade.idOportunidade = null;
    } else {
      this.filtroOportunidade.idOportunidade = Number(this.filtroOportunidade.idOportunidade);
    }

    this.dialogRef.close(this.filtroOportunidade);
  }

  fechar() {
    this.dialogRef.close();
  }

  adicionouUsuario($event) {
    if ($event.idFuncion == -1) {
      this.filtroOportunidade.usuarios = [-1];
    } else if ($event.idFuncion == 0) {
      this.filtroOportunidade.usuarios = [0];
    } else {
      this.filtroOportunidade.usuarios = this.filtroOportunidade.usuarios.filter(p => p !== -1 && p !== 0);
    }
  }
}
